exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "\n\n.EmptyEmail_wrapper_15WZ8 {\n  width: 22rem;\n  margin-top: 40px;\n}\n\n.EmptyEmail_wrapper_15WZ8 > p {\n  text-align: center;\n  font-weight: 700;\n  margin-bottom: 5px;\n}\n\n.EmptyEmail_noSavedEmail_3_HPI {\n  width: 100%;\n}\n\n.EmptyEmail_noSavedEmail_3_HPI input[type='email'] {\n  width: 100%;\n  border: 2px solid #ccc;\n  padding: 10px 15px;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\n\n.EmptyEmail_errorText_2n4BQ {\n  color: #d0021b;\n  font-size: 0.8rem;\n  display: none;\n  font-style: italic;\n  font-family: 'proxima-nova', sans-serif;\n  font-weight: 600;\n  padding-top: 5px;\n}\n", ""]);

// exports
exports.locals = {
	"wrapper": "EmptyEmail_wrapper_15WZ8",
	"noSavedEmail": "EmptyEmail_noSavedEmail_3_HPI",
	"errorText": "EmptyEmail_errorText_2n4BQ"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[name]_[local]_[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/containers/CartPage/EmptyEmail.css
// module id = 988
// module chunks = 0